import type { PlanSet } from '../../types/planSets';
import {
  BASELINE_PLANS,
  VARIANT_C_PLANS,
  WW_PRICING_C_PLANS,
} from '../../../shared/utils/SubscriptionPlans';
import {
  PRICING_11_PLANS,
  PRICING_12_PLANS,
  PRICING_13_PLANS,
  PRICING_14_PLANS,
  PRICING_15_PLANS,
  PRICING_21_PLANS,
  PRICING_22_PLANS,
  PRICING_23_PLANS,
  PRICING_24_PLANS,
  PRICING_25_PLANS,
  PRICING_31_PLANS,
  PRICING_32_PLANS,
  PRICING_33_PLANS,
  PRICING_34_PLANS,
  PRICING_35_PLANS,
  US_PRICING_TEST_2_A_PLANS,
  US_PRICING_TEST_2_B_PLANS,
  US_PRICING_TEST_2_C_PLANS,
  US_PRICING_TEST_2_D_PLANS,
  US_PRICING_TEST_2_E_PLANS,
} from '../../../shared/utils/funnelPricingPlans';
import { EMAIL_LANDING_PLANS } from '../../../shared/utils/emailLandingPlans';
import { UPSELL_111_PLANS } from '../../../shared/utils/upsell111Plans';

export const PLAN_SET = {
  BASELINE: 'baseline',
  VARIANT_C: 'variant-c',
  UPSELL_111: 'upsell-111',
  WW_PRICING_C: 'ww-pricing-c',
  EMAIL_LANDING: 'email-landing',
  PRICING_11: 'pricing-11',
  PRICING_12: 'pricing-12',
  PRICING_13: 'pricing-13',
  PRICING_14: 'pricing-14',
  PRICING_15: 'pricing-15',
  PRICING_21: 'pricing-21',
  PRICING_22: 'pricing-22',
  PRICING_23: 'pricing-23',
  PRICING_24: 'pricing-24',
  PRICING_25: 'pricing-25',
  PRICING_31: 'pricing-31',
  PRICING_32: 'pricing-32',
  PRICING_33: 'pricing-33',
  PRICING_34: 'pricing-34',
  PRICING_35: 'pricing-35',
  US_PRICING_TEST_2_A: 'us-pricing-test-2-a',
  US_PRICING_TEST_2_B: 'us-pricing-test-2-b',
  US_PRICING_TEST_2_C: 'us-pricing-test-2-c',
  US_PRICING_TEST_2_D: 'us-pricing-test-2-d',
  US_PRICING_TEST_2_E: 'us-pricing-test-2-e',
} as const;

export const PLAN_SETS: Record<PlanSet, SubscriptionModel[]> = {
  [PLAN_SET.BASELINE]: BASELINE_PLANS,
  [PLAN_SET.VARIANT_C]: VARIANT_C_PLANS,
  [PLAN_SET.UPSELL_111]: UPSELL_111_PLANS,
  [PLAN_SET.WW_PRICING_C]: WW_PRICING_C_PLANS,
  [PLAN_SET.EMAIL_LANDING]: EMAIL_LANDING_PLANS,
  [PLAN_SET.PRICING_11]: PRICING_11_PLANS,
  [PLAN_SET.PRICING_12]: PRICING_12_PLANS,
  [PLAN_SET.PRICING_13]: PRICING_13_PLANS,
  [PLAN_SET.PRICING_14]: PRICING_14_PLANS,
  [PLAN_SET.PRICING_15]: PRICING_15_PLANS,
  [PLAN_SET.PRICING_21]: PRICING_21_PLANS,
  [PLAN_SET.PRICING_22]: PRICING_22_PLANS,
  [PLAN_SET.PRICING_23]: PRICING_23_PLANS,
  [PLAN_SET.PRICING_24]: PRICING_24_PLANS,
  [PLAN_SET.PRICING_25]: PRICING_25_PLANS,
  [PLAN_SET.PRICING_31]: PRICING_31_PLANS,
  [PLAN_SET.PRICING_32]: PRICING_32_PLANS,
  [PLAN_SET.PRICING_33]: PRICING_33_PLANS,
  [PLAN_SET.PRICING_34]: PRICING_34_PLANS,
  [PLAN_SET.PRICING_35]: PRICING_35_PLANS,
  [PLAN_SET.US_PRICING_TEST_2_A]: US_PRICING_TEST_2_A_PLANS,
  [PLAN_SET.US_PRICING_TEST_2_B]: US_PRICING_TEST_2_B_PLANS,
  [PLAN_SET.US_PRICING_TEST_2_C]: US_PRICING_TEST_2_C_PLANS,
  [PLAN_SET.US_PRICING_TEST_2_D]: US_PRICING_TEST_2_D_PLANS,
  [PLAN_SET.US_PRICING_TEST_2_E]: US_PRICING_TEST_2_E_PLANS,
};
